import React from "react";
import Input from "../../../../ui/common/Input";
import "./TentaclesSettingsForms.scss";
import { getFieldValue } from "../fieldValue";
import JsonTextArea from "../../../../ui/common/JsonTextArea";

const ClassificationsForm = ({ data, handleChanges }) => {
  return (
    <div className="inputs-container tentacles-classifications-form-container">
      <Input
        value={getFieldValue(data.classificationsUpdateRate)}
        type="number"
        onChange={(e) => {
          handleChanges("classificationsUpdateRate", e.target.valueAsNumber);
        }}
        label="Classifications Update Rate"
        fullWidth
        separateLines
      />
      <JsonTextArea
        label="Clicks"
        value={getFieldValue(data.clicks)}
        onChange={(value) => {
          handleChanges("clicks", value);
        }}
      />
      <JsonTextArea
        label="Loyalty"
        value={getFieldValue(data.loyalty)}
        onChange={(value) => {
          handleChanges("loyalty", value);
        }}
      />
    </div>
  );
};

export default ClassificationsForm;
